import { useState } from 'react';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { useRepository } from '@/Application/Providers/Repository';
import { addToSaveForLater } from '@/modules/cart/application/addToSaveForLater';
import type { Cart } from '@/modules/cart/domain/Cart';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendShippingEvents';
import { ShippingEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/types';
import type { MutatorHook } from '@/sections/shared/types/MutatorHook';

interface Entity {
  lineItemId: string;
  sku: string;
}

const useAddToSaveForLater = (): MutatorHook<Entity, Cart | undefined> => {
  const { cart: cartRepository } = useRepository();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const sendGtmEvent = (type: string) => {
    sendEvent({
      event: 'baseEvent',
      extraFields: {
        'event-interactive-tag':
          type === 'error'
            ? ShippingEventInteractiveTags.CantSaveProducts
            : ShippingEventInteractiveTags.ProductSaved
      }
    });
  };

  const trigger = async ({ sku, lineItemId }: Entity) => {
    setIsLoading(true);
    try {
      const res = await addToSaveForLater(cartRepository, sku, lineItemId);

      if (!res) {
        sendGtmEvent('error');
        toast({
          status: 'error',
          title: 'No pudimos guardar este producto.',
          body: 'Por favor, vuelve a intentar.'
        });
      } else {
        sendGtmEvent('success');
        toast({
          status: 'success',
          title: '¡Genial! Guardaste tu producto con éxito.'
        });
      }

      return res;
    } catch (e) {
      sendGtmEvent('error');

      toast({
        status: 'error',
        title: 'No pudimos guardar este producto.',
        body: 'Por favor, vuelve a intentar.'
      });
      setError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return { trigger, isLoading, error };
};

export default useAddToSaveForLater;
